module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kpi"
  }, [(_vm.isLoading) ? _c('loading') : _vm._e(), (!_vm.isLoading) ? _c('bar-chart', {
    attrs: {
      "isHorizontal": false,
      "series": _vm.series,
      "categories": _vm.categories,
      "yAxisTitle": "Solicitudes",
      "tooltipFormatter": _vm.tooltipFormatter,
      "xAxisTitle": "Jefes",
      "title": "Solicitudes de vacaciones pendientes",
      "subtitle": "Cantidad de Solicitudes de vacaciones pendientes por aprobar por jefe",
      "showLegend": false,
      "showXlabels": true
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b3b1dc5e","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/kpis/c_kpi_solicitudes_v_pendiente_aprobar_jefe.vue
// module id = 946
// module chunks = 0